import { render } from "./HlxTableCell.vue?vue&type=template&id=1dcbf223"
import script from "./HlxTableCell.vue?vue&type=script&lang=js"
export * from "./HlxTableCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__